import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { FreeMember } from '../domain/dtos/free-member'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetFreeMembers {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: { groupId: string; groupResourceId: string }): Promise<FreeMember[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/groupWhitelist/listMembersByGroupResourceId/pt`,
      body: { data: { ...input } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result
    }

    throw new GeneralError()
  }
}
